import React, { useState } from "react"
import StyledMobileMenu from "./MobileMenu.style"
import Content from "../../particles/Content"
import Logo from "../../atoms/Logo/Logo"
import { Link } from "gatsby"
import Menu from "../../molecules/Menu/Menu"
import { useMobileMenuData } from "../../particles/hooks/useMobileMenuData"

const MobileMenu = () => {
  const [isOpen, setOpen] = useState(false)
  const mobileMenu = useMobileMenuData()

  const handleChange = () => {
    setOpen(!isOpen)
    isOpen
      ? document.body.classList.remove(`no-scroll`)
      : document.body.classList.add(`no-scroll`)
  }

  return (
    <StyledMobileMenu>
      <Content className="mobile-header">
        <Link to="/">
          <Logo height={115} maxWidth={150} />
        </Link>
        <button
          className={`hamburger hamburger--collapse ${isOpen ? `active` : ``}`}
          type="button"
          onClick={handleChange}
        >
          <div className="inner">
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>
        </button>
      </Content>
      <div className={`mobileMenu ${isOpen ? `open` : `closed`}`}>
        <Menu
          fontColor="white"
          menuItems={[...mobileMenu]}
          onClick={handleChange}
          mobile
        />
      </div>
    </StyledMobileMenu>
  )
}

export default MobileMenu
